// Import React and necessary hooks from 'react' library
import React, { useEffect } from 'react';

// Import Grid component from Material UI
import Grid from "@mui/material/Grid";

// Import DeviceDetector component from relative path
import DeviceDetector from '../../components/DeviceDetector';

// Define functional component 'DataDeletion'
const DataDeletion = () => {
    // Extract query parameters from URL
    const urlParams = new URLSearchParams(window.location.search);

    // Extract 'medium' parameter from URL query
    const medium = urlParams.get('medium');

    // Check if 'medium' parameter is valid
    let isMedium = medium && medium !== undefined && medium !== null && medium !== "" && (medium === "android" || medium === "tizen" || medium === "roku" || medium === "ios" || medium === "webos") ? true : false;

    // Effect hook to run side effects
    useEffect(() => {
        // If medium is not valid, add 'light' class to element with id 'header'
        if (!isMedium) {
            document.querySelector('#header').classList.add('light');
        } else {
            // If medium is valid, return true
            return true;
        }
    }, []);

    // Render component
    return (
        <section
            className="thumb_slider_section"
            style={{ position: "relative" }}
        >
            <div className="container-fluid containerWrapper">
                <div className="listingPage">
                    {/* Grid item for Data Deletion section */}
                    <Grid item xs={12} className="pt-0 w-100 staticData">
                        {/* Heading for Data Deletion section */}
                        <h3 className="text-white hd text-capitalize">
                            Deleting your Shalom Television account
                        </h3>

                        {/* Information about data deletion */}
                        <p>Shalom Television does not save your personal data on our server. According to Shalom Television policy, we have to provide User Data Deletion Callback URL or Data Deletion Instructions URL.</p>

                        {/* Note for users deciding to delete their account */}
                        <b>A few things to note if you decide to delete your Shalom Television account:</b>
                        <ul>
                            <li>Once your account is permanently deleted, you’ll need to sign up for a new account if you want to use Shalom Television again.</li>
                        </ul>

                        {/* Instructions for deleting activities */}
                        <b>If you want to delete your activities for Shalom Television Login, you can remove your information by following these steps:</b>
                        <ul>
                            <li>Drop a mail to <a href='mailto:ott@shalomonline.net'>ott@shalomonline.net</a> for your Account Deletion</li>
                            <li>Congratulations, you have successfully removed your app activities.</li>
                        </ul>

                        {/* Additional information about data deletion */}
                        <p>** We will delete your account and your data within the next 48 hours. You will receive a notification via your email or mobile number.</p>
                    </Grid>
                </div>
            </div>
        </section>
    );
}

// Export the DataDeletion component as default
export default DataDeletion;
